export class SlideShowHelper {
  static getVisibleSlides(index: number, currentSlide: number, isGridView: boolean) {
    if (isGridView) {
      return index >= currentSlide * 9 && index <= currentSlide * 9 + 8;
    }
    return index === currentSlide;
  }

  static updateCurrentSlide(slideIndex: number, direction: number, currentSlides: number) {
    return (slideIndex + direction + currentSlides) % currentSlides;
  }

  static setProgress(loaded: number) {
    // slow down the loading animation the closer it gets to 100%
    return Math.round((Math.atan(loaded) / (Math.PI / 2)) * 100 * 1000) / 1000;
  }

  static extractSlideNrFromName(displayName: string) {
    if (displayName && displayName.includes(',')) {
      const lastCommaIndex = displayName.lastIndexOf(',');
      return displayName
        .slice(lastCommaIndex + 1)
        .trim()
        .replace('Slide ', '');
    } else return undefined;
  }
}
